import axios from "axios";

export default {
  receiveUpdate() {
    return new Promise((resolve, reject) => {
      let dialog = false;
      let data = store.state.user;

      let dataFMH = store.state.userFMH;
      let organizationsHandleCodeList = [];
      // if (data.organizations) {
      // data.organizations.map((e) => {
      //   organizationsHandleCodeList.push(e.code);
      // });

      let query = `#graphql
      query($query: TicketReceiveRuleHasReceiveQueryInput!) {
        ticketReceiveRule{
          hasReceive(query: $query) {
          }
        }
      }`;
      let option = {
        query: query,
        variables: {
          query: { userName: dataFMH.userName },
        },
      };
      axios
        .request({
          url: `${config.api.api}/graphql${name ? "?queryName=" + name : ""}`,
          method: "POST", // 默认 post 请求
          data: option,
          headers: {
            Authorization: "Bearer" + " " + store.state.urlToken,
          },
        })
        .then((res) => {
          if (res) {
            let code = res.data.data.ticketReceiveRule.hasReceive;
            if (code && !data.receiveLinkName) {
              // if (code) {
              console.log(code, "hasReceive");
              dialog = code;
              resolve(dialog);
            } else {
              resolve(dialog);
            }
          }
        });
      // }
    });
  },

  phoneLengthVerify(e) {
    // 证件判断长度 6~18位数 其他不限制
      var reg = /^1[0-9]{10}$/;
      return reg.test(e);
  },
  lengthValid() {
    // 证件判断长度 6~18位数 其他不限制
    var reg = /^\w{6,18}$/;
    return reg.test(card);
  },
  idCardValid(id) {
    // 1 "验证通过!", 0 //校验不通过
    var format =
      /^(([1][1-5])|([2][1-3])|([3][1-7])|([4][1-6])|([5][0-4])|([6][1-5])|([7][1])|([8][1-2]))\d{4}(([1][9]\d{2})|([2]\d{3}))(([0][1-9])|([1][0-2]))(([0][1-9])|([1-2][0-9])|([3][0-1]))\d{3}[0-9xX]$/;
    //号码规则校验
    if (!format.test(id)) {
      return false;
    }
    //区位码校验
    //出生年月日校验   前正则限制起始年份为1900;
    var year = id.substr(6, 4), //身份证年
      month = id.substr(10, 2), //身份证月
      date = id.substr(12, 2), //身份证日
      time = Date.parse(month + "-" + date + "-" + year), //身份证日期时间戳date
      now_time = Date.parse(new Date()), //当前时间戳
      dates = new Date(year, month, 0).getDate(); //身份证当月天数
    if (time > now_time || date > dates) {
      return {
        status: 0,
        msg: "出生日期不合规",
      };
    }
    //校验码判断
    var c = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2); //系数
    var b = new Array("1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"); //校验码对照表
    var id_array = id.split("");
    var sum = 0;
    for (var k = 0; k < 17; k++) {
      sum += parseInt(id_array[k]) * parseInt(c[k]);
    }
    if (id_array[17].toUpperCase() != b[sum % 11].toUpperCase()) {
      //   return { 'status': 0, 'msg': '身份证校验码不合规' }
      return false;
    }
    // return { 'status': 1, 'msg': '校验通过' }
    return true;
  },

  isHKCard(card) {
    // 港澳居民来往内地通行证
    // 规则： H/M + 10位或6位数字
    // 样本： H1234567890
    var reg = /^([A-Z]\d{6,10}(\(\w{1}\))?)$/;
    if (reg.test(card) === false) {
      //   return { 'status': 0, 'msg': '港澳居民来往内地通行证号码不合规' };
      return false;
    } else {
      //   return { 'status': 1, 'msg': '校验通过' };
      return true;
    }
  },
  isPhoneNumber(phone) {
    // 港澳居民来往内地通行证
    // 规则： H/M + 10位或6位数字
    // 样本： H1234567890
    var reg = /^(1)[0-9]{10}$/;
    if (reg.test(phone) === false) {
      return false;
    } else {
      return true;
    }
  },
  isPassPortCard(card) {
    // 护照
    // 规则： 14/15开头 + 7位数字, G + 8位数字, P + 7位数字, S/D + 7或8位数字,等
    // 样本： 141234567, G12345678, P1234567
    var reg = /^([a-zA-z]|[0-9]){5,17}$/;
    if (reg.test(card) === false) {
      //   return { 'status': 0, 'msg': '护照号码不合规' };
      return false;
    } else {
      //   return { 'status': 1, 'msg': '校验通过' };
      return true;
    }
  },
  isTWCard(card) {
    // 台湾居民来往大陆通行证
    // 规则： 新版8位或18位数字， 旧版10位数字 + 英文字母
    // 样本： 12345678 或 1234567890B
    var reg = /^\d{8}|^[a-zA-Z0-9]{10}|^\d{18}$/;
    if (reg.test(card) === false) {
      //   return { 'status': 0, 'msg': '台湾居民来往大陆通行证号码不合规' };
      return false;
    } else {
      //   return { 'status': 1, 'msg': '校验通过' };
      return true;
    }
  },

  carPhoneValid(vehicleNumber) {
    // const plateNumber = /^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DF])|([DF]([A-HJ-NP-Z0-9])[0-9]{4})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1})$/
    // if (plateNumber.test(carNum)=== false) {
    //   return false
    // } else {
    //   return true
    // }
    // var xreg=/^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DF]$)|([DF][A-HJ-NP-Z0-9][0-9]{4}$))/;
    var xxreg =
      /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1,2}$/; // 2021年新能源车牌不止有DF

    var creg =
      /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1}$/;

    if (vehicleNumber.length == 7) {
      return creg.test(vehicleNumber);
    } else if (vehicleNumber.length == 8) {
      return xxreg.test(vehicleNumber);
    } else {
      return false;
    }
  },
  engineNoValid(carNum) {
    const plateNumber = /^[A-Z0-9a-z\d]{7,8}$/;
    if (plateNumber.test(carNum) === false) {
      return false;
    } else {
      return true;
    }
  },

  getAll(begin, end) {
    let arr1 = begin.split("-");
    let arr2 = end.split("-");
    let arr1_ = new Date();
    let arrTime = [];
    //   let dataTimesAggregate = []
    arr1_.setUTCFullYear(arr1[0], arr1[1] - 1, arr1[2]);
    let arr2_ = new Date();
    arr2_.setUTCFullYear(arr2[0], arr2[1] - 1, arr2[2]);
    let unixDb = arr1_.getTime();
    let unixDe = arr2_.getTime();
    for (let k = unixDb; k <= unixDe; ) {
      arrTime.push(this.datetimeparse(k, "YY/MM/DD"));
      // dataTimesAggregate.push(this.datetimeparse(k, 'YY-MM-DD'))
      k = k + 24 * 60 * 60 * 1000;
    }

    //   console.log(arrTime)
    //   this.date = arrTime

    return arrTime;
  },

  // 时间格式处理
  datetimeparse(timestamp, format, prefix) {
    if (typeof timestamp === "string") {
      timestamp = Number(timestamp);
    }
    // 转换时区
    let currentZoneTime = new Date(timestamp);
    let currentTimestamp = currentZoneTime.getTime();
    let offsetZone = currentZoneTime.getTimezoneOffset() / 60; // 如果offsetZone>0是西区，西区晚
    let offset = null;
    // 客户端时间与服务器时间保持一致，固定北京时间东八区。
    offset = offsetZone + 8;
    currentTimestamp = currentTimestamp + offset * 3600 * 1000;

    let newtimestamp = null;
    if (currentTimestamp) {
      if (currentTimestamp.toString().length === 13) {
        newtimestamp = currentTimestamp.toString();
      } else if (currentTimestamp.toString().length === 10) {
        newtimestamp = currentTimestamp + "000";
      } else {
        newtimestamp = null;
      }
    } else {
      newtimestamp = null;
    }

    let dateobj = newtimestamp ? new Date(parseInt(newtimestamp)) : new Date();
    let YYYY = dateobj.getFullYear();
    let MM =
      dateobj.getMonth() > 8
        ? dateobj.getMonth() + 1
        : "0" + (dateobj.getMonth() + 1);
    let DD =
      dateobj.getDate() > 9 ? dateobj.getDate() : "0" + dateobj.getDate();
    let HH =
      dateobj.getHours() > 9 ? dateobj.getHours() : "0" + dateobj.getHours();
    let mm =
      dateobj.getMinutes() > 9
        ? dateobj.getMinutes()
        : "0" + dateobj.getMinutes();
    let ss =
      dateobj.getSeconds() > 9
        ? dateobj.getSeconds()
        : "0" + dateobj.getSeconds();
    let output = "";
    let separator = "/";
    if (format) {
      separator = format.match(/-/) ? "-" : "/";
      output += format.match(/yy/i) ? YYYY : "";
      output += format.match(/MM/) ? (output.length ? separator : "") + MM : "";
      output += format.match(/dd/i)
        ? (output.length ? separator : "") + DD
        : "";
      output += format.match(/hh/i) ? (output.length ? " " : "") + HH : "";
      output += format.match(/mm/) ? (output.length ? ":" : "") + mm : "";
      output += format.match(/ss/i) ? (output.length ? ":" : "") + ss : "";
    } else {
      output += YYYY + separator + MM + separator + DD;
    }
    output = prefix ? prefix + output : output;

    return newtimestamp ? output : "";
  },

  // 根据身份证判断年龄是否满18周岁
  /**
   * 根据身份证号得到性别和精确计算年龄
   */
  analyzeIDCard(IDCard) {
    //获取用户身份证号码
    var userCard = IDCard;
    //如果身份证号码为undefind则返回空
    if (!userCard) {
      return false;
    }
    //获取出生年月日
    var yearBirth = userCard.substring(6, 10);
    var monthBirth = userCard.substring(10, 12);
    var dayBirth = userCard.substring(12, 14);
    //获取当前年月日并计算年龄
    var myDate = new Date();
    var monthNow = myDate.getMonth() + 1;
    var dayNow = myDate.getDate();
    var age = myDate.getFullYear() - yearBirth;
    if (
      monthNow < monthBirth ||
      (monthNow == monthBirth && dayNow < dayBirth)
    ) {
      age--;
    }
    if (age >= 18) {
      return true;
    }
    return false;
  },

  strlen(str) {
    var len = 0;
    for (var i = 0; i < str.length; i++) {
      var c = str.charCodeAt(i);
      //单字节加1
      if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
        len++;
      } else {
        len += 2;
      }
    }
    return len;
  },

  dateCom() {
    let date = new Date(),
      year = date.getFullYear(), //获取完整的年份(4位)
      month = date.getMonth() + 1, //获取当前月份(0-11,0代表1月)
      strDate = date.getDate(); // 获取当前日(1-31)
    const HH =
      new Date().getHours() < 10
        ? "0" + new Date().getHours()
        : new Date().getHours();
    const mm =
      new Date().getMinutes() < 10
        ? "0" + new Date().getMinutes()
        : new Date().getMinutes();
    const ss =
      new Date().getSeconds() < 10
        ? "0" + new Date().getSeconds()
        : new Date().getSeconds();

    if (month >= 1 && month <= 9) month = "0" + month; // 如果月份是个位数，在前面补0
    if (strDate >= 0 && strDate <= 9) strDate = "0" + strDate; // 如果日是个位数，在前面补0

    let isNow = `${year}${month}${strDate}${HH}${mm}${ss}`;
    // debugger
    let is826 = "20240828180000";
    // 如果现在的时间大于等于28号 就返回false
    if (isNow < is826) {
      return true;
    } else {
      return false;
    }
  },

  // 今晚24点（8-23日24点）关闭人证申请的入口，包括批量导入、草稿箱提交、单条申请
  closeApplication() {
    let date = new Date(),
      year = date.getFullYear(), //获取完整的年份(4位)
      month = date.getMonth() + 1, //获取当前月份(0-11,0代表1月)
      strDate = date.getDate(); // 获取当前日(1-31)
    const HH =
      new Date().getHours() < 10
        ? "0" + new Date().getHours()
        : new Date().getHours();
    const mm =
      new Date().getMinutes() < 10
        ? "0" + new Date().getMinutes()
        : new Date().getMinutes();
    const ss =
      new Date().getSeconds() < 10
        ? "0" + new Date().getSeconds()
        : new Date().getSeconds();

    if (month >= 1 && month <= 9) month = "0" + month; // 如果月份是个位数，在前面补0
    if (strDate >= 0 && strDate <= 9) strDate = "0" + strDate; // 如果日是个位数，在前面补0

    let isNow = `${year}${month}${strDate}${HH}${mm}${ss}`;
    // debugger
    let is826 = "20230830120000";
    // 如果现在的时间大于等于24号 就返回false
    if (isNow < is826) {
      return true;
    } else {
      return false;
    }
  },

  // if(!this.regular.dateCom()){
  //   this.$router.push('/company/card/list')
  //   return
  // }
};
